import { render, staticRenderFns } from "./ValueWithCurrency.vue?vue&type=template&id=53ed0a44&scoped=true&"
import script from "./ValueWithCurrency.vue?vue&type=script&lang=js&"
export * from "./ValueWithCurrency.vue?vue&type=script&lang=js&"
import style0 from "./ValueWithCurrency.vue?vue&type=style&index=0&id=53ed0a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ed0a44",
  null
  
)

export default component.exports